import { render } from "./kiosk.vue?vue&type=template&id=053ed008&scoped=true&ts=true"
import script from "./kiosk.vue?vue&type=script&lang=ts"
export * from "./kiosk.vue?vue&type=script&lang=ts"

import "./kiosk.vue?vue&type=style&index=0&id=053ed008&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053ed008"]])

export default __exports__